var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06641 8C2.06641 4.41015 4.97656 1.5 8.56641 1.5C12.1563 1.5 15.0664 4.41015 15.0664 8C15.0664 9.28267 14.6949 10.4786 14.0536 11.4859C13.1841 12.8517 11.8187 13.871 10.211 14.2902C9.96086 14.3554 9.71207 14.1978 9.6442 13.9484C9.57422 13.6912 9.72052 13.4316 9.96013 13.328C9.97179 13.323 9.98367 13.3183 9.99576 13.3141C10.0033 13.3114 10.011 13.3089 10.0187 13.3065L10.0341 13.302C12.3591 12.6598 14.0664 10.5293 14.0664 8C14.0664 4.96243 11.604 2.5 8.56641 2.5C5.52884 2.5 3.06641 4.96243 3.06641 8C3.06641 8.03474 3.06673 8.06939 3.06737 8.10396C3.07173 8.33964 3.09093 8.5717 3.12406 8.79925L3.62193 7.83617C3.74874 7.59086 4.05039 7.49481 4.2957 7.62162C4.541 7.74843 4.63706 8.05009 4.51025 8.29539L3.51033 10.2296C3.44623 10.3536 3.33321 10.4452 3.19861 10.4822C3.064 10.5191 2.92007 10.4982 2.80162 10.4243L0.895673 9.23588C0.66135 9.08978 0.589837 8.78138 0.735944 8.54705C0.882051 8.31273 1.19045 8.24122 1.42477 8.38733L2.11755 8.81929C2.0838 8.55094 2.06641 8.2775 2.06641 8Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 10.7773C11.2628 11.0071 10.9524 11.0692 10.7226 10.916L7.7226 8.91602C7.5835 8.82329 7.49995 8.66718 7.49995 8.5V4.5C7.49995 4.22386 7.7238 4 7.99995 4C8.27609 4 8.49995 4.22386 8.49995 4.5V8.23241L11.2773 10.084C11.5071 10.2372 11.5691 10.5476 11.416 10.7773Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Restore.3ba9fd8e73f003eae7c570464213dcfb.svg";